export type ResolvedTheme = "light" | "dark";

export const THEME_CHROME_COLORS = {
  dark: "#171717",
  light: "#fafafa",
} as const satisfies Record<ResolvedTheme, string>;

function setMetaContent(name: string, content: string): void {
  if (typeof document === "undefined") {
    return;
  }

  let meta = document.head.querySelector<HTMLMetaElement>(
    `meta[name="${name}"]`,
  );
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export function applyThemeChrome(resolvedTheme: ResolvedTheme): void {
  if (typeof document === "undefined") {
    return;
  }

  const color = THEME_CHROME_COLORS[resolvedTheme];
  setMetaContent("theme-color", color);
  setMetaContent("msapplication-TileColor", color);
  const maskIcon = document.head.querySelector<HTMLLinkElement>(
    'link[rel="mask-icon"]',
  );
  maskIcon?.setAttribute("color", color);
}
